export const LABELS = {
  applyButtonLabel: 'Apply',
  archived: 'Archived',
  cancelButtonLabel: 'Cancel',
  editTitle: 'Edit issue title',
  emptySections: {
    branchesOrLinkedPullRequests: 'No branches or linked pull requests',
    relationships: 'None yet',
    participants: 'No participants',
    development: 'No branches or pull requests',
    releases: 'No releases found',
  },
  unavailableSections: {
    relationships: 'Relationships are currently unavailable',
    development: 'Development is currently unavailable',
    notifications: 'Notifications are currently unavailable',
    participants: 'Participants are currently unavailable',
    tryAgainLater: 'Please try again later',
  },
  filterProjects: 'Filter projects',
  issueNumber: (issueNumber: number) => `#${issueNumber}`,
  issueTypes: {
    noIssueTypeOptionName: 'None',
    issueTypeDialogHeader: 'Select issue type',
  },
  lock: {
    title: 'Lock conversation on this issue',
    titleUnlock: 'Unlock conversation on this issue',
    buttonConfirmLock: 'Lock conversation',
    buttonConfirmUnlock: 'Unlock conversation',
  },
  noDescriptionProvided: 'No description provided.',
  notifications: {
    unsubscribedAnnouncement: "You're now unsubscribed from this issue.",
    unsubscribedButton: 'Subscribe',
    subscribedOptionLabel: 'SUBSCRIBED',
    unsubscribedDescription: "You're not receiving notifications from this thread.",
    subscribedAnnouncement: "You're now subscribed to this issue.",
    subscribedButton: 'Unsubscribe',
    subscribedDescription: "You're receiving notifications because you're subscribed to this thread.",
    unsubscribedOptionLabel: 'UNSUBSCRIBED',
    notificationsSettings: 'Notifications settings',
    notificationsTitle: 'Notifications',
    notSubscribedOption: 'Not subscribed',
    subscribedOption: 'Subscribed',
    customOption: 'Custom',
    customOptionLabel: 'CUSTOM',
    customOptions: 'Custom options',
    closed: 'Closed',
    closedLabel: 'CLOSED',
    reopened: 'Reopened',
    reopenedLabel: 'REOPENED',
    customizeNotificationsSettings: 'Customize',
    customizeNotificationsSettingsUpdated: 'Customize: Updated',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    errorMessage: 'An error occurred. Please try again.',
    preferencesSaved: 'Notification preferences saved',
  },
  optionsTitle: 'Issue actions',
  organization: 'Organization',
  private: 'Private',
  prPickerDescription: 'Link pull requests',
  public: 'Public',
  pullRequest: 'Pull request',
  repository: 'Repository',
  user: 'User',
  sectionTitles: {
    relationships: 'Relationships',
    development: 'Development',
    participants: 'Participants',
    releases: 'Releases',
  },
  relationNames: {
    parentIssue: 'Parent issue',
    blockedByIssues: 'Blocked by',
    blockingIssues: 'Is blocking',
    relatesToIssues: 'Relates to',
    securityAlerts: 'Security alert',
  },
  relatesToActions: {
    add: 'Add relates to',
    addOrChange: 'Add or change relates to',
  },
  relatesToPickerSubtitle: 'Mark issues that relate to the current issue…',
  relationViewAll: 'View all',
  relationLoadingList: 'Loading related items...',
  relationListAllError:
    "We couldn't load the related issues. Try reloading the page, or if the problem persists, contact support.",
  emptyBlockedByList: 'No blocked by issues found',
  emptyBlockingList: 'No blocking issues found',
  emptySecurityAlertsList: 'No linked security alerts found',
  emptyRelatesToList: 'No related issues found',
  loadMoreItems: 'Load more',
  development: {
    createBranch: 'Create a branch',
    creatingBranch: (repositoryWithOwner: string | null | undefined) =>
      repositoryWithOwner ? `Creating in ${repositoryWithOwner}…` : 'Creating branch…',
    creatingBranchStatus: (branchName: string, repositoryWithOwner: string) =>
      `Creating branch ${branchName} in ${repositoryWithOwner}.`,
    branchCreated: 'Branch created',
    createBranchFailed: 'Branch not created',
    retryCreateBranch: 'Try again',
    repositoryPickerNav: 'Return to repository picker',
    createBranchSuffix: 'for this issue or link a pull request.',
    repoPickerSubtitle: 'Select a repository to search for branches and pull requests or',
    prsBranchesPickerSubtitle: 'Link a branch, pull request, or',
    closingReferenceCannotUnlink: 'Edit the pull request description to unlink',
    copilot: {
      openWorkspace: 'Open in Workspace',
      openAgent: 'Code with agent mode',
      error: (message: string) => `Codespace creation failed. ${message}`,
    },
  },
  selectProjects: 'Select projects',
  tasks: (completed: number, total: number) =>
    completed === 0 ? `${total} task${total > 1 ? 's' : ''}` : `${completed} of ${total}`,
  timeline: {
    pinned: 'pinned this issue',
  },
  transfer: {
    title: 'Transfer issue',
    subtitle:
      'This does not scrub any issue content. Content such as text references to other issues, pull requests, projects and teams will still appear in the description or comments. Labels will be transferred.',
    started: 'Issue transfer has started. This action might take a while.',
    repoUnavailable: 'Issue cannot be transferred to this repository.',
  },
  convertToDiscussion: {
    title: 'Convert issue to a discussion',
    whatHappens: 'What happens when an issue is converted into a discussion:',
    affirmations: {
      closedAndLocked: 'Issue will be closed and locked',
      same: 'Title, description, and author will be the same as the issue',
      commentsAndReactions: 'All comments and reactions will be the same as the issue',
    },
    warnings: {
      taskListBlocks: 'Discussions do not have tasklists',
      assignees: 'Discussions do not have assignees',
      projects: 'Discussions cannot be added to projects',
      milestone: 'Discussions do not have milestones',
    },
    selectCategoryTitle: 'Category for new discussion',
    error: (message: string) => `ConvertIssueToDiscussion mutation failed with error: ${message}`,
    converted: 'This issue has been moved to a discussion',
    goToDiscussion: 'Go to the discussion',
  },
  unsavedChangesContent: 'Are you sure you want to discard them?',
  unsavedChangesTitle: 'You have unsaved changes',
  viewDescriptionPlaceholder: 'Add a description',
  viewTitlePlaceholder: 'Title',
  linkedPrsLabel: 'Linked pull requests',
  mergedPrs: 'Fixed by',
  openPrs: 'Remaining',
  somethingWentWrong: 'Something went wrong! Please try again',
  signedOutBanner: {
    signUp: 'to join this conversation on GitHub.',
    signIn: 'Already have an account?',
  },
  linkedSecurityAlertsLabel: 'Linked security alerts',
  fixedSecurityAlerts: 'Fixed',
  openSecurityAlerts: 'Remaining',
  dismissedSecurityAlerts: 'Dismissed',
}
